

function generateUniqueId() {
  // 获取当前时间的毫秒时间戳
  var timestamp = new Date().getTime();

  // 生成一个5位的随机数
  var randomNum = Math.floor(Math.random() * 90000) + 10000; // 生成10000到99999之间的随机数

  // 将时间戳和随机数结合
  var combined = timestamp + '' + randomNum;

  // 使用MD5生成唯一ID
  var uniqueId = md5(combined);

  return uniqueId;
}

var clientOldId = localStorage.getItem("clientId");
if (!clientOldId) {
    localStorage.setItem("clientId", generateUniqueId());
}

// 生成并打印唯一ID
console.log(generateUniqueId(), '====generateUniqueId()===');

// 浏览器通知相关
// document.addEventListener('readystatechange', () => {
//     var state = document.readyState
//     if (state == 'interactive') {
//         setTimeout(() => {
//             subscribe()
//         }, 3000)
//     }
// });

// async function subscribe() {
//     try {
//         const serviceWorker = await navigator.serviceWorker.register('https://www.heychic.com.au/cdn/shop/t/297/assets/serviceWorker.js');
//         const subscription = await serviceWorker.pushManager.subscribe({
//             userVisibleOnly: true,
//             applicationServerKey: 'BJ3QhOMzY1Sl2-gKrvO3WfmXr2TJAEV8sTsILmk7jaMzCUMEz5WcNZc3IdrumUw2r86uYWU2jOSxodR_3-JN_j8'
//         });
//         const key = subscription.getKey('p256dh');
//         const token = subscription.getKey('auth');
//         const contentEncoding = (PushManager.supportedContentEncodings || ['aesgcm'])[0];
    
//         await fetch('https://dev.api.shop.heychic.com.au/Notify/subscribe', {
//             method: 'POST',
//             body: JSON.stringify({
//                 endpoint: subscription.endpoint,
//                 publicKey: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
//                 authToken: token ? btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null,
//                 contentEncoding,
//                 clientId: localStorage.getItem("clientId"),
//             }),
//             headers: {
//                 'Content-Type': 'application/json'
//             }
//         });
//     } catch (error) {
//         console.log( error);
//     }
// }

// if ('serviceWorker' in navigator) {
//     navigator.serviceWorker.register('https://www.heychic.com.au/cdn/shop/t/297/assets/serviceWorker.js')
//         .then(registration => {
//             console.log('Service Worker registered:', registration);
//         })
//         .catch(error => {
//             console.log('Service Worker registration failed:', error);
//         });
// }

// 心愿单相关！
function toAddWish(event) {
    let isLike = event.classList.contains('wishlist-added')
    var productNumber = event.getAttribute("data-product-id");
    var productHandle = event.getAttribute("data-wishlist-handle");
    if(isLike) { // 当前是喜欢的 走取消收藏
        delWish({
            'product_handle': productHandle
        })
    } else { // 当前是不喜欢的 走添加收藏
        addWish({
            'product_number': productNumber,
            'product_handle': productHandle
        })
    }
        
    // 获取相邻的类名为'common-product-wish-num'的DOM元素
    var nearEvent = event.nextElementSibling;
    
    // 判断是否存在相邻元素且类名为'common-product-wish-num'或者'product-wish-num' 一个是列表类名 一个是详情类名
    if (nearEvent && (nearEvent.classList.contains('common-product-wish-num') || nearEvent.classList.contains('product-wish-num'))) {
        // 获取当前值并加1
        var currentValue = parseInt(nearEvent.textContent);
        var num = isLike ? -1 : 1 // 喜欢+1 不喜欢-1
        var newValue = currentValue + num;
        
        // 更新DOM元素的值
        nearEvent.textContent = newValue;
        // if(!isLike){
        //     nearEvent.style.color = '#E05E2A';
        // }else{
        //     nearEvent.style.color = '#272727';
        // }
    }
}



// 添加心愿单 
var commonHeaders = new Headers();
commonHeaders.append("Content-Type", "application/json");
commonHeaders.append("X-Shop-Id", '59363262637');//正式
// commonHeaders.append("X-Shop-Id",'66793275449');//测试

function addWish(data) {
    const raw = JSON.stringify({
        ...data,
        "client_id": localStorage.getItem("clientId"),
        "customer_id": ShopifyAnalytics.meta.page.customerId || ''
    });

    const requestOptions = {
        method: "POST",
        headers: commonHeaders,
        body: raw,
        redirect: "follow"
    };
      
    fetch(`/apps/user-api/web/wish/add`, requestOptions) //正式
        .then((response) => response.text())
        .then((result) => console.log(result))
        .catch((error) => console.error(error));
}

// 取消收藏
function delWish(data) {
    const raw = JSON.stringify({
        ...data,
        "client_id": localStorage.getItem("clientId"),
        "customer_id": ShopifyAnalytics.meta.page.customerId || ''
    });

    const requestOptions = {
    method: "POST",
    headers: commonHeaders,
    body: raw,
    redirect: "follow"
    };

    fetch(`/apps/user-api/web/wish/del`, requestOptions) //正式
    .then((response) => response.text())
    .then((result) => console.log(result))
    .catch((error) => console.error(error));
}
